import {
  APP_ZONES,
  NotificationAlertTypeEnum,
  PermissionConfig,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
} from '@finxone-platform/shared/sys-config-types';

export const getV1_0_170ToV1_0_171 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: function () {
        return 'v1.0.171';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        //look for all the transaction history and exchange history widgets in all the zones the widget can be placed, as per zone-list-array.ts
        roles.forEach((item) => {
          const zonesToUpdate = [item.zones[APP_ZONES.PROFILE]];
          zonesToUpdate.forEach((zone) => {
            if (zone) {
              const mobilePages = zone?.canvases?.subscription?.['default']?.mobile?.pages as
                | WorkflowPageConfig[]
                | undefined;
              const desktopPages = zone?.canvases?.subscription?.['default']?.desktop?.pages as
                | WorkflowPageConfig[]
                | undefined;

              const tabletPages = zone?.canvases?.subscription?.['default']?.tablet?.pages as
                | WorkflowPageConfig[]
                | undefined;
              if (mobilePages?.length) {
                findPageAndUpdateWidget(mobilePages);
              }
              if (desktopPages?.length) {
                findPageAndUpdateWidget(desktopPages);
              }
              if (tabletPages?.length) {
                findPageAndUpdateWidget(tabletPages);
              }
            }
          });
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
          projectForms: permissionSection.projectForms,
        };
      },
    },
  };
};

function findPageAndUpdateWidget(pagesArray: WorkflowPageConfig[]) {
  /**
   * Finds a page that has a transaction history widget and update its transactionContext property.
   *
   */
  for (const page of pagesArray) {
    if (!page) continue;
    page.widgets = page.widgets.map((widget) => {
      if (widget.name === WidgetNames.NOTIFICATION_WIDGET) {
        if (
          widget.widgetConfiguration?.attributes?.widgetProperties?.notificationSettings?.['category'] ===
          'transactionAlerts'
        ) {
          if (widget.widgetConfiguration?.attributes?.widgetProperties?.notificationSettings) {
            widget.widgetConfiguration.attributes.widgetProperties.notificationSettings.category =
              NotificationAlertTypeEnum.TRANSACTIONS_SUCCESS_AND_FAILURE_ALERTS;
          }
        }
      }

      return widget;
    });
  }
  return pagesArray;
}
